import {
  getIrr,
  getRoi,
  getIrrConclusion,
  getIrrChartsData,
  getRoiChartsData,
  getLoanRateChartData,
  getLoanConclusionTitle,
  getLoanProfitChartData,
  getTaxSavingsConclusion,
  getInvestmentAccConclusion,
  getEarlySaleProfitConclusion,
  getLoanConclusionDescription,
  getInvestorCashFlowConclusion,
  getPositiveCashFlowConclusion,
} from "./Conclusions.helpers";

import Conclusions from "./Conclusions";

const ConclusionsContainer = ({
  className,
  activePosition,
  conclusionsPro,
  proCalculation,
  proCalculationCharts,
  energyEfficiencyClass,
}: {
  className?: string;
  activePosition: 10 | 20 | 30;
  calculation: any;
  conclusionsPro: any;
  proCalculation: any;
  proCalculationCharts: any;
  energyEfficiencyClass: string;
}) => {
  const userScenarioResult = conclusionsPro?.userScenarioResult;

  const irr = getIrr({
    conclusionsPro,
    userScenarioResult,
    activePosition,
  });

  const roi = getRoi({
    conclusionsPro,
    userScenarioResult,
    activePosition,
  });

  const irrConclusion = getIrrConclusion(irr);
  const irrChartsData = getIrrChartsData({
    userScenarioResult,
    activePosition,
    conclusionsPro,
    proCalculation,
  });
  const roiChartsData = getRoiChartsData({
    userScenarioResult,
    activePosition,
    conclusionsPro,
    proCalculation,
  });

  const positiveCashFlowConclusion = getPositiveCashFlowConclusion({
    conclusionsPro,
    userScenarioResult,
  });

  const investorCashFlowConclusion = getInvestorCashFlowConclusion({
    activePosition,
    conclusionsPro,
    userScenarioResult,
    proCalculation,
  });

  const taxSavingsConclusion = getTaxSavingsConclusion({
    activePosition,
    conclusionsPro,
    userScenarioResult,
    proCalculation,
  });

  const conclusionTitle = getLoanConclusionTitle({
    activePosition,
    userScenarioResult,
    conclusionsPro,
  });

  const conclusionDescription =
    getLoanConclusionDescription(userScenarioResult);

  const loanProfitChartData = getLoanProfitChartData({
    activePosition,
    conclusionsPro,
    userScenarioResult,
    proCalculation,
  });

  const loanRateChartData = getLoanRateChartData({
    activePosition,
    conclusionsPro,
    userScenarioResult,
    proCalculation,
  });

  const earlySaleProfitConclusion = getEarlySaleProfitConclusion({
    proCalculation,
    activePosition,
    conclusionsPro,
  });

  const investmentAccConclusion = getInvestmentAccConclusion({
    activePosition,
    conclusionsPro,
    proCalculation,
  });

  return (
    <Conclusions
      className={className}
      activePosition={activePosition}
      irr={irr}
      roi={roi}
      userScenarioResult={userScenarioResult}
      irrConclusion={irrConclusion}
      irrChartsData={irrChartsData}
      roiChartsData={roiChartsData}
      conclusionTitle={conclusionTitle}
      loanRateChartData={loanRateChartData}
      loanProfitChartData={loanProfitChartData}
      taxSavingsConclusion={taxSavingsConclusion}
      proCalculationCharts={proCalculationCharts}
      conclusionDescription={conclusionDescription}
      energyEfficiencyClass={energyEfficiencyClass}
      investmentAccConclusion={investmentAccConclusion}
      earlySaleProfitConclusion={earlySaleProfitConclusion}
      positiveCashFlowConclusion={positiveCashFlowConclusion}
      investorCashFlowConclusion={investorCashFlowConclusion}
    />
  );
};

export default ConclusionsContainer;
